// [목적] 금액 배열 → 정수 퍼센트 배열(합계 정확히 100) — 최대잔여법(largest remainder method)
// [이유] P1-04(2026-09-19 QA): 예산 카테고리별 비율을 각각 Math.round(amt/total*100) 로 독립 반올림하면
//        카테고리 수가 늘수록 합이 100 을 넘거나 못 미치는 경우가 발생한다(예: 45/30/25 → 반올림 시 46+30+25=101).
//        각 항목을 내림(floor)한 뒤, 버려진 소수부(나머지)가 큰 순서대로 1%p 씩 배분해 합계를 100 으로 맞춘다.
// [사이드 이팩트] 없음(순수 함수).
// [수정 시 고려사항] amounts 는 음수 없는 값만 가정(호출부가 이미 clamp). 합계가 0 이면 전부 0 반환.
export function distributePercentages(amounts: readonly number[]): number[] {
  const total = amounts.reduce((sum, v) => sum + v, 0);
  if (total <= 0) return amounts.map(() => 0);

  const raw = amounts.map((v) => (v / total) * 100);
  const floors = raw.map((v) => Math.floor(v));
  const remainder = 100 - floors.reduce((sum, v) => sum + v, 0);

  const orderByFraction = floors
    .map((_, i) => i)
    .sort((a, b) => raw[b]! - floors[b]! - (raw[a]! - floors[a]!));

  const result = [...floors];
  for (let i = 0; i < remainder; i++) {
    const idx = orderByFraction[i];
    if (idx !== undefined) result[idx] = (result[idx] ?? 0) + 1;
  }
  return result;
}
